export { cookieStorageStrategy } from './cookieStorageStrategy';
export { localStorageStrategy } from './localStorageStrategy';
export { noOpStrategy } from './noOpStrategy';
export { sessionStorageStrategy } from './sessionStorageStrategy';
